// ----------------------------------------------------------------------------
// Component: Klaviyo Embed Form
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// Styles
import './_klaviyo-embed-form.scss';
